var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_25_428)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "url(#paint0_linear_25_428)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 33C43.5006 33.2546 43.4353 33.5051 43.3105 33.727C43.1856 33.949 43.0055 34.1348 42.7875 34.2665L29.28 42.5297C29.0523 42.6691 28.7914 42.7452 28.5244 42.7502C28.2575 42.7551 27.994 42.6887 27.7613 42.5578C27.5307 42.4289 27.3387 42.2409 27.2049 42.0132C27.0711 41.7855 27.0004 41.5263 27 41.2622V24.7378C27.0004 24.4737 27.0711 24.2144 27.2049 23.9867C27.3387 23.759 27.5307 23.5711 27.7613 23.4422C27.994 23.3112 28.2575 23.2448 28.5244 23.2498C28.7914 23.2547 29.0523 23.3308 29.28 23.4703L42.7875 31.7334C43.0055 31.8651 43.1856 32.051 43.3105 32.2729C43.4353 32.4949 43.5006 32.7453 43.5 33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_25_428",
    x: -5,
    y: -5,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_25_428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_25_428",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_428",
    x1: -2.75,
    y1: 68.2,
    x2: 35.9602,
    y2: -4.33594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190425,
    stopColor: "#FF5740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902773,
    stopColor: "#FFE419"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.2c76fb9354e769d9df692fb5e9f4a75d.svg";
export { ForwardRef as ReactComponent };